export default __webpack_public_path__ + "static/media/LandingPage.5e1213b3.svg";